// extracted by mini-css-extract-plugin
export default {"page":"ClientBillingAdmin_page__+w71z"};